const key = "fake-business-products";

const applicable = (resp) => {
	// api/businesses/${businessCode}/products
	return (resp.config.method === "GET" || resp.config.method === "POST" || resp.config.method === "PUT") 
		&& (resp.config.url.match(/api\/businesses\/[0-9]*\/products$/));
};

const modify = (resp) => {
	if(resp.status !== 404 && resp.status !== 403 && resp.status !== 405) {
		throw resp;
	}

	resp.status = 200;
	resp.data.Success = true;
	delete resp.data.Errors;
	delete resp.data.Informations;
	if(resp.config.method === "GET") {
		resp.data.Data = [
			{
				Code: "a0ac9ec3-3add-46c1-bfb6-9116222aa5e3",
				Name: "Bag of ice",
				Unit: "Bag",
				Price: 5.5,
				IsInvoiceDefault: false,
				IsActive: true,
				Fees: [
					{ Code: "6230d4e6-bb01-4fcf-8327-f6d13b6037f4" },
					{ Code: "e38f6658-5bdd-41dc-b48d-457ee013ee76" }
				]
			},
			{
				Code: "a837a86f-f182-440f-8eb6-ce051fb5c014",
				Name: "Gasoline",
				Unit: "Gallon",
				Price: 10,
				IsInvoiceDefault: true,
				IsActive: true
			},
			{
				Code: "a0f444aa-1900-4e19-9c8c-b19ada9b4884",
				Name: "Gloves",
				Unit: "Pair",
				Price: 4,
				IsInvoiceDefault: false,
				IsActive: false
			}
		];
	}

	if(resp.config.method === "POST") {
		resp.data.Data = {
			...resp.config?.data,
			Code: "35f622ac-7474-4207-b6f8-0d8019046af6"
		};
	}

	if(resp.config.method === "PUT") {
		resp.data.Data = {
			...resp.config?.data
		};
	}

	return resp;
};

export const fakeBusinessProducts = [key, applicable, modify];